import { Avatar, Tag, Typography } from "antd";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

const getInitials = (fullName) => {
  const initials = fullName.split(" ").map((name) => name[0]);
  return initials.join("").toUpperCase();
};

const statusColor = (status) => {
  switch (status) {
    case "overdue":
      return "#ef4444";
    case "due":
      return "#f59e0b";
    case "upcoming":
      return "#10b981";
  }
};

const FollowUpItem = ({ item, index }) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "20px 0px 20px 12px",
        borderTop: index === 0 ? "none" : "1px solid rgba(255,255,255,0.05)",
        cursor: "pointer",
      }}
      onClick={() => navigate(`/patient-cabinet/${item.patient_id}`)}
    >
      {/* Left side */}
      <div style={{ display: "flex", gap: 12 }}>
        <Avatar
          style={{
            backgroundColor: "#a855f7",
            fontWeight: 600,
          }}
        >
          {getInitials(item.patient_name)}
        </Avatar>

        <div>
          <Text style={{ color: "#fff", fontWeight: 500 }}>
            {item.patient_name}
          </Text>
          <br />
          <Text style={{ color: "#94a3b8", fontSize: 13 }}>{item.email}</Text>
        </div>
      </div>

      {/* Right */}
      <Tag
        style={{
          background: statusColor(item.status_type),
          color: "#fff",
          borderRadius: 999,
          padding: "4px 10px",
          border: "none",
          fontSize: 12,
        }}
      >
        {item.status}
      </Tag>
    </div>
  );
};

export default FollowUpItem;
